type ParamSource =
	| URLSearchParams
	| Readonly<Record<string, string | undefined>>;

export function getTypedParam(
	source: ParamSource,
	key: string,
	type: NumberConstructor,
): number | undefined;

export function getTypedParam(
	source: ParamSource,
	key: string,
	type: StringConstructor,
): string | undefined;

export function getTypedParam(
	source: ParamSource,
	key: string,
	type: NumberConstructor | StringConstructor,
): number | string | undefined {
	const rawValue =
		source instanceof URLSearchParams ? source.get(key) : source[key];

	if (rawValue == null) return undefined;
	if (type === String) return rawValue;
	if (rawValue.trim() === "") return undefined;

	const value = Number(rawValue);
	return Number.isFinite(value) ? value : undefined;
}
